import { Drawer, DrawerContent } from "@arc-ui/components";
import { SideBarProps } from "../../../types/ee-header";
import NestedMenu from "./NestedMenu";

export const SideBar = ({ open, onClose }: Readonly<SideBarProps>) => {
  return (
    <Drawer
      isOpen={open}
      onRequestClose={onClose}
      position="left"
      size="m"
      shouldReturnFocus
      width={"80%"}
      aria-label="Navigation Menu"
      ariaDescription="Navigation menu"
    >
      <DrawerContent isFullBleed={true}>
        <NestedMenu />
      </DrawerContent>
    </Drawer>
  );
};
